export default {
  login: "계속하려면 로그인하십시오...",
  password_rule: "* 암호는 대문자와 소문자를 구별하고 길이는 6자~10자여야 합니다.",
  nickname_rule: "* 로그인 및 화면에 표시할 닉네임을 설정하세요(6~15글자의 영숫자). 닉네임은 한 번만 설정할 수 있습니다. 한 번 설정하면 수정이나 취소가 불가능합니다.",
  change_password_succeed: "비밀번호 변경 성공",
  add_secondary_succeed: "닉네임 설정 성공",
  succeed: "작업을 성공적으로 완료했습니다!",
  failed: "작업을 완료하지 못했습니다!",
  no_information_available: "상세 정보를 볼 수없습니다",
  select_display_language: "선호하는 기본 언어를 선택하십시오.",
  select_odds_type: "선호하는 기본 승산 유형 표시를 선택하십시오.",
  select_page_type: "오늘과 초기 시장 페이지 모두에 표시 할 기본 페이지 유형을 기본으로 선택하십시오.",
  select_show_score_map: "베팅을하는 동안 시스템이 맵 점수를 자동으로 표시하도록합니다.",
  select_default_event_sorting: "선호하는 기본 이벤트 정렬 표시를 선택하십시오.",
  select_market_type: "선호하는 시장을 선택하십시오.",
  select_page_size: "원하는 페이지 크기를 선택하십시오",
  change_sports_menu_order: "스포츠 메뉴 오더의 순서를 변경하려면 해당 항목을 드래그하십시오.",
  view_outstanding_bets_in_bet_list: "미완료 베팅을 처리하려면 약간의 시간이 소요될 수 있습니다. 내 최신 미완료 베팅을 확인하시려면 베팅 목록으로 이동해 주십시오.",
  time_display_in_gmt_plus_8: "시간은GMT+8기준으로표시됩니다.",
  select_default_stake: "시스템이 맞춤형 스테이크 및 마지막 베팅 스테이크를 자동으로 입력 할 수 있도록합니다.",
  bet_empty: "베팅 슬립이 비어 있습니다.. 베팅을 선택하려면 테이블의 배당률을 클릭하십시오.",
  no_event: "현재 가능한 경기 또는 게임이 없습니다. 다른 스포츠 이벤트 또는 게임을 방문하시고 나중에 다시 접속해 주세요.",
  no_bets: "진행 중인 베팅 없음",
  no_waiting: "대기 베팅이 없습니다.",
  no_void: "무효 베팅 없음",
  confirmation: "이 베팅을 하시겠습니까?",
  olderversion: "이전 버전이 감지되면 확인을 클릭하여 업데이트하거나 Ctrl-F5를 누르십시오.",
  gmt8: "시간은GMT+8기준으로표시됩니다.",
  confirm_bet: "내기 확인?",
  match_not_started: "경기가 시작되지 않았습니다",
  odds_changed: "로 배당률이 변경 되였습니다",
  to: "to",

  login2: "로그인하고 게임에 액세스하려면 먼저 계정을 등록해야합니다. 이미 계정이있는 경우 계속 로그인하십시오.",

  button_skip: "투어 건너뛰기",
  button_previous: "이전",
  button_next: "다음",
  button_stop: "완료",
  button_continue: "계속",
};
